import React, { useState } from 'react';

import { HeaderBar } from './AppHeader.styles';
import HeaderLogo from './HeaderLogo';
import HeaderNavGroups from './HeaderNavGroups';
import HeaderUser from './HeaderUser';

interface AppHeaderProps {
  user: {
    name: string;
    email: string;
  };
}

export const AppHeader: React.FC<AppHeaderProps> = ({ user }) => {
  return (
    <HeaderBar>
      <HeaderLogo />
      <HeaderNavGroups />
      <HeaderUser user={user} />
    </HeaderBar>
  );
};
